<template>
  <div class="text-input" :class="{ hasError: errorMessages.length > 0 }">
    <label :for="`input_${inputIdentifier}`">
      {{displayName}}
    </label>
    <v-text-field
      v-model="modelValue"
      v-bind="$attrs"
      v-validate="validations"
      :error="errorMessages > 0"
      :hide-details="true"
      :data-vv-as="displayName"
      :data-vv-name="inputIdentifier"
      :id="`input_${inputIdentifier}`"
      :name="inputIdentifier"
      flat
      single-line
      solo
      ref="text-input-common" />
  </div>
</template>

<script>
const nonCharacterRegex = /([^a-z0-9])/g;
const duplicatedHyphensRegex = /-+/g;
const startEndHyphensRegex = /(^-)|(-$)/g;
const capitalCharacterRegex = /([A-Z])/g;

export default {
  inject: ['$validator'],
  props: {
    displayName: {
      type: String,
      required: true,
    },
    identifier: {
      type: String,
      default: '',
    },
    validations: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    errorMessages() {
      return (this.errors && this.errors.collect)
        ? this.errors.collect(this.inputIdentifier)
        : [];
    },
    inputIdentifier() {
      if (this.identifier) {
        return this.identifier;
      }

      return this.displayName
        .replace(capitalCharacterRegex, '-$1')
        .toLowerCase()
        .replace(nonCharacterRegex, '-')
        .replace(duplicatedHyphensRegex, '-')
        .replace(startEndHyphensRegex, '');
    },
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';

.v-input {
  border: solid 1px rgba(0,0,0, 0.15);
  border-radius: 4px;
  overflow: hidden;
}

.v-input--is-focused {
  box-shadow: 0 0 1px  $theme-color-primary;
  border: 1px solid $theme-color-primary;
}

::v-deep .v-text-field__details {
  display: none;
}

::v-deep .v-input__slot {
  margin: 0;
}

::v-deep input {
  border: none;
  color: rgba(0, 0, 0, 0.7);
  font-size: 1rem;
  margin: 0;
  padding: 10px 15px;

  &:focus {
    border: none;
    box-shadow: none;
    outline: none;
  }
}

.hasError {
  label {
    color: $theme-color-alert;
  }

  .v-input {
    border-color: rgba($theme-color-alert, 0.5);
  }

  ::v-deep input {
    color: $theme-color-alert;
  }
}
</style>
